/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 */
window.addEventListener('pageshow', function() {
	let overlay = document.querySelector('.PageTransition')
	if (overlay && overlay.style.opacity != 0) {
		overlay.style.opacity = 0
	}
})

// Checks if a size variant is selected
window.isSizeSelected = function(context) {
	context = context || document;
	var sizeRadios = context.querySelectorAll('.SizeSwatch__Radio');
	
	// If there are no size radios, check if it's a gift card
	if (sizeRadios.length === 0) {
		// Check for gift card value selection
		var giftCardRadios = context.querySelectorAll('.SwatchList--gift-card .Swatch__Radio');
		
		// If there are no gift card radios either, validation passes (single variant product)
		if (giftCardRadios.length === 0) {
			return true;
		}
		
		// Check if any gift card value is selected
		for (var i = 0; i < giftCardRadios.length; i++) {
			if (giftCardRadios[i].checked) {
				return true;
			}
		}
		
		// No gift card value selected
		return false;
	}
	
	// For regular products with sizes, check if size is selected
	for (var i = 0; i < sizeRadios.length; i++) {
		if (sizeRadios[i].checked) {
			return true;
		}
	}
	
	return false;
}


//  Shows the size error message
window.showSizeError = function() {
	var sizeError = document.getElementById('size-error');
	if (sizeError) {
		sizeError.classList.remove('hidden');
	}
}


// Hides the size error message
window.hideSizeError = function() {
	var sizeError = document.getElementById('size-error');
	if (sizeError) {
		sizeError.classList.add('hidden');
	}
}


// Validates size selection and shows error if needed
window.validateSizeSelection = function(event, context) {
	if (!window.isSizeSelected(context)) {
		if (event) {
			event.preventDefault();
			event.stopPropagation();
		}
		window.showSizeError();
		return false;
	}
	return true;
}

/*============================================================================
  pdp find in store
==============================================================================*/

;(function() {
	var microModalOptions = {
		openTrigger: "data-micromodal-trigger",
		closeTrigger: "data-micromodal-close",
		openClass: "is-open",
		disableScroll: true,
		disableFocus: false,
		awaitOpenAnimation: false,
		awaitCloseAnimation: false,
		debugMode: true,
	};
	var microModalInitialised = false;

	function onReady(callback) {
		if (document.readyState === 'loading') {
			document.addEventListener('DOMContentLoaded', callback);
			return;
		}

		callback();
	}

	function whenMicroModalReady(callback) {
		var done = false;
		var attempts = 0;

		function run() {
			if (done || !window.MicroModal) return;

			done = true;
			callback();
		}

		function wait() {
			if (window.MicroModal) {
				run();
				return;
			}

			attempts += 1;
			if (attempts < 120) {
				window.requestAnimationFrame(wait);
			}
		}

		if (window.MicroModal) {
			run();
			return;
		}

		wait();
		window.addEventListener('load', function() {
			run();
		}, { once: true });
	}

	function initMicroModal() {
		if (!window.MicroModal || microModalInitialised) return;

		MicroModal.init(microModalOptions);
		microModalInitialised = true;
	}

	function openModal(modalId) {
		whenMicroModalReady(function() {
			initMicroModal();

			document.querySelectorAll('.modal.is-open').forEach(function(modal) {
				if (modal.id !== modalId) {
					modal.classList.remove('is-open');
					modal.setAttribute('aria-hidden', 'true');
				}
			});

			// #668: lets the Stock Availability engine lazy-load its data before the modal shows.
			document.dispatchEvent(new CustomEvent('findinstore:open', { detail: { modalId: modalId } }));
			MicroModal.show(modalId, microModalOptions);
		});
	}

	onReady(function() {
		whenMicroModalReady(initMicroModal);

		if (window.location.pathname.includes('/products/')) {
			const modalTriggers = document.querySelectorAll('[data-micromodal-trigger="findInStoreModal"], [data-micromodal-trigger="clickAndCollectModal"]');

			modalTriggers.forEach(function(trigger) {
				trigger.addEventListener('click', function(event) {
					var section = trigger.closest('[data-section-type="product"]') || document.querySelector('[data-section-type="product"]');
					var modalId = trigger.getAttribute('data-micromodal-trigger');

					// #668: the Stock Availability modal has its own size selector, so it skips the page size gate.
					if (modalId !== 'findInStoreModal' && !window.validateSizeSelection(event, section || document)) {
						event.stopImmediatePropagation();
						return false;
					}

					if (modalId) {
						event.preventDefault();
						event.stopImmediatePropagation();
						openModal(modalId);
					}
				}, true);
			});
		}

	// Hide size error when a size is selected
	if (window.location.pathname.includes('/products/')) {
	  const sizeRadios = document.querySelectorAll('.SizeSwatch__Radio');

	  // Hide error when user selects a size
	  sizeRadios.forEach(function(radio) {
	    radio.addEventListener('change', window.hideSizeError);
	  });

	  // Hide error when user selects a gift card value
	  const giftCardRadios = document.querySelectorAll('.SwatchList--gift-card .Swatch__Radio');
	  giftCardRadios.forEach(function(radio) {
	    radio.addEventListener('change', window.hideSizeError);
	  });
	}
	});
})();

// document.addEventListener('product:added', function(event) {
// 	console.log(event);
// 	console.log('Product added to cart');
// });
